import conversaMixin from 'common/mixins/conversa'

export default {
  props: {
    sofiaFilters: { type: Array, default: () => [] },
    userPermissionModules: { type: Array, default: () => [] },
    mode: { type: String, default: undefined }
  },
  mixins: [conversaMixin],
  components: {
    'sofia-filter-modals-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/sofia/SofiaFilterModals'
    )
  },
  data() {
    return {
      saveStatusVisible: false,
      documentTitleVisible: false,
      tirantCloud: {},
      sofia: {}
    }
  },
  computed: {
    user_path() {
      return `${gon.app_tolgeo}/${this.$user_id}/${this.$subscription_id}/`
    },
    is_subscription_user() {
      return this.$subscription_id != ''
    },
    aiWriteActions(){
      return gon.sofia.ai_write_actions
    },
  },
  methods: {
    getSofiaToken(path) {
      return this.getServiceToken('sofia', { fav: path, permissions: this.userPermissionModules })
    },
    get_tirantcloud_token() {
      let params = {
        folder_path: this.folder_path,
        storage_type: this.storage_type || ""
      }

      return this.getServiceToken('tirantcloud', params)
    },
    
    openSofiaFilterModal(selectedModal) {
      this.$refs['sofia-filter-modals'].showModal(
        selectedModal.tipoid,
        selectedModal.field
      )
    },
    confirmFilterValues(tipoid, name, selectedValues) {
      this.sofia.eventBus.publish('sofia:setted-filter-values', tipoid, name, selectedValues)
    }
  },
  mounted() {
    this.tirantCloud = new TirantCloud({
      lang: this.$language,
      tolgeo: gon.app_tolgeo,
      paisiso: gon.paisiso,
      baseEndpoint: this.$cloud_service_url,
      tokenFunction: this.get_tirantcloud_token,
      sofiaBaseEndpoint: this.$sofia_service_url + '/',
      sofiaTokenFunction: this.getSofiaToken,
      saveStatusVisible: this.saveStatusVisible,
      favouritesEnabled: this.is_subscription_user,
      pdfJsUrl: this.url_for_pdfjs_library(),
      isExtEditable: false,
      allowedExtensions: ['.pdf', '.txt', '.rtf', '.doc', '.docx', '.odt', '.html', '.ott', '.sxw'],
      documentLang: this.documentLang,
      showNewDocumentMenu: this.show_new_document_menu,
      documentTitleVisible: this.documentTitleVisible,
      sofiaFilters: this.sofiaFilters,
      onSofiaOpenFilterModal: this.openSofiaFilterModal,
      permissions: this.userPermissionModules,
      aiWriteActions: this.aiWriteActions,
      sofiaShowModelSelector: gon.sofia.show_model_selector,
      conversaOptions: this.conversaOptions(this.mode == 'workspace'),
      mode: this.mode
    })

    this.tirantCloud.publicEventBus.subscribe('sofia:created', (sofia) => {
      this.sofia = sofia
      this.sofia.eventBus.subscribe('sofia:modal-cleared',(tipoid, field) => {
        this.$refs['sofia-filter-modals'].clearModal(tipoid, field)
      })
    })
  }
}
